import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import imageIndex from "../ImageIndex";

const collaboratorsLogos = [
  {
    src: imageIndex.CoecytjalLogo,
    link: "https://sicyt.jalisco.gob.mx/inicio",
    name: "special",
  },
  {
    src: imageIndex.SicytLogo,
    link: "https://l.coecytjal.org.mx/",
    name: "special",
  },
  {
    src: imageIndex.JaliscoLogo,
    link: "https://www.jalisco.gob.mx/inicio",
    name: "special",
  },
  {
    src: imageIndex.SecretariaEconomiaLogo,
    link: "https://www.gob.mx/se",
    name: "special",
  },
  {
    src: imageIndex.GuadalajaraGudalajara,
    link: "https://visitagdl.com",
    name: "special",
  },
  {
    src: imageIndex.GobiernoSayulaLogo,
    link: "https://www.sayula.gob.mx/",
    name: "special",
  },
  {
    src: imageIndex.FEMIALogo,
    link: "https://femiamx.com/#!/-inicio-4-2/",
    name: "special",
  },
  {
    src: imageIndex.UMGLogo,
    link: "https://umg.edu.mx/portal/",
    name: "",
  },
  {
    src: imageIndex.ESTESLogo,
    link: "https://estesrockets.com/",
    name: "",
  },
  {
    src: imageIndex.CelestronLogo,
    link: "https://www.celestronmexico.com/",
    name: "",
  },
  {
    src: imageIndex.Explora,
    link: "https://www.exploraspace.com",
    name: "",
  },
  {
    src: imageIndex.NoMADALogo,
    link: "https://nomada-industries.com",
    name: "",
  },
  {
    src: imageIndex.ConsejoAeroespacialDeJaliscoLogo,
    link: "https://www.facebook.com/CAJaliscoMX",
    name: "",
  },

  {
    src: imageIndex.TripoliNLLogo,
    link: "https://www.facebook.com/CAJaliscoMX",
    name: "",
  },

  {
    src: imageIndex.ThrustersUnlimitedBlancoLogo,
    link: "https://thrustersunlimited.space",
    name: "",
  },
  { src: imageIndex.FAULogo, link: "https://www.fau.org.mx", name: "" },

  {
    src: imageIndex.HackerLogo,
    link: "https://zacatecas.hackergarage.mx",
    name: "",
  },

  {
    src: imageIndex.AFACLogo,
    link: "https://www.gob.mx/afac",
    name: "",
  },
];

const sponsorsLogos = [
  { src: imageIndex.OptimenLogo, link: "https://www.optimen.com.mx", name: "" },
  { src: imageIndex.XpertmeLogo, link: "https://xpertme.com", name: "" },
  {
    src: imageIndex.DaviLogo,
    link: "https://laboratorioparaconstruccion.com",
    name: "",
  },
  {
    src: imageIndex.NoMADALogo,
    link: "https://nomada-industries.com",
    name: "",
  },
  { src: imageIndex.GrupoSSCLogo, link: "https://www.grupossc.com", name: "" },
  { src: imageIndex.AnsysLogo, link: "https://www.ansys.com", name: "" },
  { src: imageIndex.SterenLogo, link: "https://www.steren.com.mx", name: "" },
  { src: imageIndex.SkarchLogo, link: "https://aguaskarch.com", name: "" },
  {
    src: imageIndex.CasioEducacionLogo,
    link: "https://casiocalculadoras.mx",
  },

  { src: imageIndex.RedColaLogo, link: "https://www.redcola.mx", name: "" },
  {
    src: imageIndex.SMMueblesLogo,
    link: "https://www.facebook.com/sm.mueblesydecoracion/?locale=es_LA",
    name: "",
  },
  {
    src: imageIndex.SidralAgaLogo,
    link: "https://www.agacentro.com",
    name: "",
  },
  { src: imageIndex.UMGLogo, link: "https://umg.edu.mx/portal/", name: "" },
  { src: imageIndex.InBestLogo, link: "https://www.inbest.cloud", name: "" },
  {
    src: imageIndex.PropulsionIndustriesLogo,
    link: "https://www.propulsion.industries",
    name: "",
  },
  {
    src: imageIndex.LugibaLogo,
    link: "https://www.instagram.com/lugiba_company?igsh=aWd0ODZ3Y3JzZjJl ",
    name: "",
  },
];

const LogoImage = styled("img")(({ theme }) => ({
  height: "80px",
  width: "auto",
  maxWidth: "100%",
  objectFit: "contain",
  transition: "transform 0.3s ease",
  margin: "0 auto",
  "&:hover": {
    transform: "scale(1.1)",
  },
  [theme.breakpoints.down("sm")]: {
    height: "60px", // Smaller on mobile
  },
}));

const CarouselContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 0),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
  position: "relative",
  overflow: "hidden",
  "& .slick-track": {
    display: "flex",
    alignItems: "center",
  },
  "& .slick-slide": {
    padding: "0 15px",
    "& > div": {
      height: "100%",
    },
  },
  "&::before, &::after": {
    content: '""',
    position: "absolute",
    top: 0,
    bottom: 0,
    width: "80px",
    zIndex: 2,
    pointerEvents: "none",
    transition: "opacity 0.3s ease",
    [theme.breakpoints.down("md")]: {
      width: "40px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "20px",
    },
  },
  "&::before": {
    left: 0,
    background: `linear-gradient(to right, ${theme.palette.background.paper} 0%, rgba(255,255,255,0) 100%)`,
  },
  "&::after": {
    right: 0,
    background: `linear-gradient(to left, ${theme.palette.background.paper} 0%, rgba(255,255,255,0) 100%)`,
  },
}));

const CarouselSettings = {
  dots: false,
  infinite: true,
  speed: 5000,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: "linear",
  arrows: false,
  pauseOnHover: false,
  rtl: false,
  swipe: false,
  touchMove: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        speed: 6000, // Slower on mobile for better visibility
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1.5, // Partial visibility of next item
        speed: 7000,
      },
    },
  ],
};

const CarouselSettingsLeft = {
  ...CarouselSettings,
  rtl: true, // Only difference is direction
};

const CollaboratorsSection = () => (
  <CarouselContainer>
    <Container>
      <Stack spacing={4} alignItems="center">
        <Typography
          variant="h2"
          component="h2"
          sx={{
            color: "white",
            textAlign: "center",
            fontSize: {
              xs: "2rem", // Mobile (extra small)
              sm: "2.5rem", // Small tablets
              md: "3rem", // Tablets
              lg: "3.2rem", // Desktop
            },
            lineHeight: 1.3,
            px: 2, // Horizontal padding
            whiteSpace: "normal", // Ensure text wraps
            wordBreak: "break-word", // Prevent overflow
            "& span": {
              color: "#34a6fe",
              display: "inline-block", // Better control of colored part
            },
          }}
        >
          Nuestros <span>colaboradores</span>
        </Typography>
        <Box
          sx={{
            width: "100%",
            px: 4,
            "& .slick-list": {
              overflow: "visible", // Allows logos to extend slightly
            },
          }}
        >
          <Slider {...CarouselSettings}>
            {[...collaboratorsLogos, ...collaboratorsLogos].map(
              (logo, index) => (
                <Box
                  key={`right-${index}`}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    px: 1, // Adjusted padding for better spacing
                  }}
                >
                  <a href={logo.link} target="_blank" rel="noopener noreferrer">
                    <LogoImage
                      src={logo.src}
                      alt={logo.name || "Collaborator logo"}
                    />
                  </a>
                </Box>
              )
            )}
          </Slider>
        </Box>
      </Stack>
    </Container>
  </CarouselContainer>
);

const SponsorsSection = () => (
  <CarouselContainer>
    <Container>
      <Stack spacing={4} alignItems="center">
        <Typography
          variant="h2"
          component="h2"
          sx={{
            color: "white",
            textAlign: "center",
            fontSize: {
              xs: "2rem", // Mobile (extra small)
              sm: "2.5rem", // Small tablets
              md: "3rem", // Tablets
              lg: "3.2rem", // Desktop
            },
            lineHeight: 1.3,
            px: 2, // Horizontal padding
            whiteSpace: "normal", // Ensure text wraps
            wordBreak: "break-word", // Prevent overflow
            "& span": {
              color: "#34a6fe",
              display: "inline-block", // Better control of colored part
            },
          }}
        >
          Nuestros <span>patrocinadores</span>
        </Typography>
        <Box
          sx={{
            width: "100%",
            px: 4,
            "& .slick-list": {
              overflow: "visible",
            },
          }}
        >
          <Slider {...CarouselSettingsLeft}>
            {[...sponsorsLogos, ...sponsorsLogos].map((logo, index) => (
              <Box
                key={`left-${index}`}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  px: 1,
                }}
              >
                <a href={logo.link} target="_blank" rel="noopener noreferrer">
                  <LogoImage src={logo.src} alt={logo.name || "Sponsor logo"} />
                </a>
              </Box>
            ))}
          </Slider>
        </Box>
      </Stack>
    </Container>
  </CarouselContainer>
);

const LogoCarousels = () => {
  return (
    <>
      <CollaboratorsSection />
      <SponsorsSection />
    </>
  );
};

export default LogoCarousels;
